module.exports = __webpack_public_path__ + "img/campaign-point.2e8e1115.png";